export default __webpack_public_path__ + "static/media/potion_02.05a2bdf7.png";